<div class="accessibility-setter zoom-{{ fontSizePercentage }}">
  <span>{{ 'accessibilitySetter.defaultTextSize' | translate}}</span>
  <div class="font-size-setting">
    <number-spinner [initial]="fontSizePercentage" [max]="150" [min]="100" [step]="10" (valueChanged)="onValueChanged($event)" [appendPercent]="true"></number-spinner>
    <button class="btn btn-light set-button" (click)="saveFontSizePercentageToStorage()">{{ 'accessibilitySetter.set' | translate}}</button>
  </div>
</div>
